import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import SalaryInformationStyles from "./SalaryInformation.style";
import CustomButton from "../../../../../global/components/CustomButton/CustomButton";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";
import { useAppSelector } from "../../../../../utils/hooks";
import { selectUserId } from "../../../../../redux/authSlice";
import { getSalaryDetails } from "../StepperServices";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import {
  isTruthy,
  openErrorNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";

interface CustomProps {
  nextStep?: () => void | undefined;
  backStep?: () => void | undefined;
}

const SalaryInformation = (props: CustomProps) => {
  const [salaryInfo, setSalaryInfo] = useState<any>([]);
  const userIdFromRedux = useAppSelector(selectUserId);
  const [apiResponse, setApiResponse] = useState(false);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      setApiResponse(true);
      const response = await getSalaryDetails(userIdFromRedux);
      customErrorHandler(response);
      setSalaryInfo(response.data);
      setApiResponse(false);
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const classes = SalaryInformationStyles;
  return (
    <Box sx={classes.contentWrapper}>
      <Box sx={classes.pageInfoHeader}>
        <Typography sx={classes.Heading}>Salary Information</Typography>
        <Typography sx={classes.text}>
          Update your Salary Information for the platform
        </Typography>
      </Box>
      <Grid container>
        <Box sx={classes.profileDetails}>
          <Grid container rowSpacing={3}>
            <Grid item xs={12}>
              <Typography sx={classes.detailsHeading}>
                Salary Details
              </Typography>
              <Typography sx={classes.subHeading}>
                Manage your bank information to use the platform
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography sx={classes.userLabal}>Basic Salary</Typography>
              <Typography sx={classes.userDetails}>
                {salaryInfo?.basic}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={classes.userLabal}>HRA</Typography>
              <Typography sx={classes.userDetails}>
                {salaryInfo?.HRA}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography sx={classes.userLabal}>Medical Allowance</Typography>
              <Typography sx={classes.userDetails}>
                {salaryInfo?.medical_allowance}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={classes.userLabal}>
                Conveyance Allowance
              </Typography>
              <Typography sx={classes.userDetails}>
                {salaryInfo?.conbeyance_allowance}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography sx={classes.userLabal}>Special Allowance</Typography>
              <Typography sx={classes.userDetails}>
                {salaryInfo?.special_allowance}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography sx={classes.userLabal}>Others</Typography>
              <Typography sx={classes.userDetails}>
                {salaryInfo?.others}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Grid item xs={2}>
          <Box sx={classes.buttonWarapper}>
            <CustomButton
              label="Back"
              buttonType="secondaryBtn"
              onClick={() => {
                props.backStep?.();
              }}
            />
            {/* <CustomButton
              label="Save"
              buttonType="primaryBtn"
              onClick={() => {}}
            /> */}
          </Box>
        </Grid>
      </Grid>
      {apiResponse && <CustomLoader apiResponse={false} />}
    </Box>
  );
};

export default SalaryInformation;
